'use client';
import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import Link from 'next/link';

export default function PositioningSection() {
  return (
    <section id="positioning" className="py-24 relative overflow-hidden" style={{ background: '#0B0F19' }}>
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse 70% 50% at 50% 50%, rgba(0,212,255,0.05) 0%, transparent 70%)' }}
      />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div
          className="rounded-3xl p-10 lg:p-16 text-center relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, rgba(0,212,255,0.08) 0%, rgba(167,139,250,0.06) 100%)',
            border: '1px solid rgba(0,212,255,0.20)',
            boxShadow: '0 8px 60px rgba(0,212,255,0.08)',
          }}
        >
          <div
            className="absolute top-0 left-0 w-full h-full pointer-events-none"
            style={{ background: 'radial-gradient(ellipse 60% 60% at 50% 0%, rgba(0,212,255,0.08) 0%, transparent 70%)' }}
          />
          <div className="relative">
            <div className="section-badge mb-6 mx-auto w-fit">
              <Sparkles size={12} />
              A Different Kind of Product
            </div>
            <h2
              className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-8"
              style={{ color: '#F0F4FF' }}
            >
              Not Another CRM.
            </h2>
            <div className="max-w-2xl mx-auto space-y-5 mb-10">
              <p className="text-xl leading-relaxed" style={{ color: 'rgba(240,244,255,0.75)' }}>
                AgentOS isn't another CRM with AI added.
              </p>
              <p className="text-xl leading-relaxed" style={{ color: 'rgba(240,244,255,0.75)' }}>
                It's an AI Business Partner that happens to include a CRM.
              </p>
              <div
                className="rounded-2xl p-6 mt-8"
                style={{
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.10)',
                }}
              >
                <p className="text-base leading-relaxed" style={{ color: 'rgba(240,244,255,0.60)' }}>
                  The AI becomes the primary experience. The CRM becomes one of many tools your AI uses to help you succeed. You talk to AgentOS the way you'd talk to a trusted business partner — and it handles the rest.
                </p>
              </div>
            </div>
            <Link
              href="/in-action"
              className="inline-flex items-center gap-2 text-base font-semibold px-7 py-3.5 rounded-xl transition-all"
              style={{
                background: 'linear-gradient(135deg, #00D4FF, #0099CC)',
                color: '#0B0F19',
                boxShadow: '0 4px 20px rgba(0,212,255,0.30)',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.boxShadow = '0 6px 28px rgba(0,212,255,0.45)';
                (e.currentTarget as HTMLElement).style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.boxShadow = '0 4px 20px rgba(0,212,255,0.30)';
                (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
              }}
            >
              See the difference
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
